module.exports = __webpack_public_path__ + "static/media/LT3-BG2.3d99161c.jpg";